import React from 'react';
import { Trophy } from 'lucide-react';

const LobbyTicker = ({ tickerItems }) => {
    return (
        <div className="bg-[#1e1e1e] overflow-hidden py-2 border-b border-white/5 relative z-20 flex">
            {/* Stream 1 */}
            <div className="animate-marquee flex shrink-0 items-center gap-12 px-6 min-w-full">
                {tickerItems.map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 font-mono whitespace-nowrap">
                        <span className="text-white font-bold text-xs">{item.email}</span>
                        <span className="text-[#F59E0B] font-bold text-xs">+Bs {item.amount}</span>
                        <span className="text-neutral-500 font-bold text-[10px] uppercase">EN {item.game}</span>
                    </div>
                ))}
            </div>

            {/* Stream 2 (Duplicate for continuous loop) */}
            <div className="animate-marquee flex shrink-0 items-center gap-12 px-6 min-w-full" aria-hidden="true">
                {tickerItems.map((item, idx) => (
                    <div key={`dup-${idx}`} className="flex items-center gap-2 font-mono whitespace-nowrap">
                        <span className="text-white font-bold text-xs">{item.email}</span>
                        <span className="text-[#F59E0B] font-bold text-xs">+Bs {item.amount}</span>
                        <span className="text-neutral-500 font-bold text-[10px] uppercase">EN {item.game}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LobbyTicker;
